import React from "react";
import { Box, Typography, Stack, Avatar, CircularProgress } from "@mui/material";
import TimeControler from './TimeController'
import Rating from '@mui/material/Rating';

const ChatMessage = ({
  msg,
  isLast,
  client,
  userAvatar,
  botAvatar,
  formatDate,
  trimCommas,
  onChange,
  setInput,
  isLoading,
  t,
  lang,
  largeText,
  input,
  // rating,
  // setRating
}) => {

  const isUser = msg.role === "user";
  // console.log(msg, 'lll')
  function capitalizeFirstLetter(valeur) {
    if (!valeur) return valeur; // Gère le cas des chaînes vides
    return valeur.charAt(0).toUpperCase() + valeur.slice(1);
  }
  return (
    <Stack
      direction="row"
      // justifyContent={isUser ? "flex-end" : "flex-start"}
      spacing={1}
      sx={{ 
        mb: 1, 
        width: "100%",
        justifyContent: isUser ? "flex-end": "flex-start",
      }}   // 👈 important
    >
      {/* BOT AVATAR */}
      {!isUser && (
        <Avatar
          src={client.logo_url || botAvatar}
          sx={{ width: 28, height: 28 }}
        />
      )}

      <Box
        sx={{
          // bgcolor: 'red',
          width:'75%'
        }}
      >
        {/* MESSAGE BUBBLE */}
        <Box
          sx={{
            px: 2,
            py: 1,
            borderRadius: 2,
            // maxWidth: "260px",
            // maxWidth: "100%",
            bgcolor: isUser
              ? client.user_message_background_color || "#0C02E1"
              : client.ai_message_background_color || "#0Fb2E7",
            color: isUser
              ? client.user_message_text_color || "#fff"
              : client.ai_message_text_color || "#fff",
            wordBreak: "break-word",
          }}
        >
          {/* TEXT */}
          {msg.type && msg.type === 'EVAL_RESULT' ? (
            <Rating
              name="simple-controlled"
              value={parseInt(msg.content)}
              readOnly
              size="large" 
            />
          ): (
            <Typography 
              variant={largeText ? "body1": "body2"}
              sx={{ whiteSpace: "pre-line" }} // ✅ important

            >
              {trimCommas(msg.content)}
            </Typography>
          )}


          {/* IMAGE */}
          {msg.image_url && (
            <Box
              component="img"
              src={msg.image_url}
              alt="chat"
              sx={{
                mt: 1,
                width: "100%",
                maxWidth: 220,
                borderRadius: 1
              }}
            />
          )}

          {isLast && isLoading && (
            <CircularProgress size={25} color="secondary" aria-label="Loading…" />
          )}

          {/* 🔘 BUTTONS (important part) */}
          {(msg?.buttons?.length > 0 && isLast) && (
            <Box sx={{ mt: 1 }}>
              {msg.buttons.map((item, i) => (
                <React.Fragment key={i}>
                
                  {/* QUICK OPTIONS */}
                  {(item.status === "Accepted_quote" ||
                    item.status === "Request_RDV" ||
                    item.status === "Consent_txt_adress" ||
                    item.status === "Consent_txt_contact") && (
                    
                    <Stack spacing={1}>
                      {item.value.map((val, j) => (
                        <Box
                          key={j}
                          component="button"
                          // onClick={() => item.onClick?.(val)}
                          onClick={(e) => onChange(val)}
                          sx={{
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            border: "none",
                            cursor: "pointer",
                            bgcolor: "#eee",
                            "&:hover": { bgcolor: "#ddd" },
                            fontSize: "0.75rem"
                          }}
                        >
                          {capitalizeFirstLetter(val)}
                        </Box>
                      ))}
                    </Stack>
                  )}

                  {/* RDV SLOT */}
                  {/* {item.status === "Slots_RDV" && isLast && item.component} */}
                  {item.status === "Slots_RDV" && isLast && (
                    <TimeControler setInput={setInput} data={item} t={t} lang={lang}/>
                  )}

                </React.Fragment>
              ))}
            </Box>
          )}

          {isLast && msg.type && msg.type === 'EVAL_MESSAGE' ? (
            <Rating
              name="simple-controlled"
              value={input}
              onChange={(event, newValue) => {
                onChange(String(newValue))
                // setRating(newValue)
              }}
            />
          ): null}


        </Box>

        {/* DATE */}
        <Typography
          variant="caption"
          sx={{
            fontSize: "0.65rem",
            color: "#888",
            mt: 0.3,
            display: "block",
            textAlign: isUser ? "right" : "left"
          }}
        >
          {formatDate(msg.created_at)}
        </Typography>
      </Box>

      {/* USER AVATAR */}
      {isUser && (
        <Avatar
          src={userAvatar}
          sx={{ width: 28, height: 28 }}
        />
      )}
    </Stack>
  );
};

export default ChatMessage;